// src/services/billingService.js
import api from './api';

// ── Admin Zenkroll ────────────────────────────────────────────────────────────

export const listarPedidosPendentes = () =>
  api.get('/billing/admin/pendentes').then(r => r.data);

export const listarTodosPedidos = (filtros = {}) => {
  const params = new URLSearchParams();
  if (filtros.status)         params.append('status',         filtros.status);
  if (filtros.instituicao_id) params.append('instituicao_id', filtros.instituicao_id);
  if (filtros.limit)          params.append('limit',          filtros.limit);
  if (filtros.offset)         params.append('offset',         filtros.offset);
  return api.get(`/billing/admin/todos-pedidos?${params}`).then(r => r.data);
};

export const confirmarPedido = (pedidoId, observacoes = '') =>
  api.post(`/billing/admin/confirmar/${pedidoId}`, { observacoes }).then(r => r.data);

export const rejeitarPedido = (pedidoId, motivo_rejeicao = '') =>
  api.post(`/billing/admin/rejeitar/${pedidoId}`, { motivo_rejeicao }).then(r => r.data);

// ── Instituição ───────────────────────────────────────────────────────────────

export const listarCatalogoModulos = () =>
  api.get('/billing/modulos').then(r => r.data);

export const listarMeusModulos = () =>
  api.get('/billing/meus-modulos').then(r => r.data);

export const solicitarModulo = (dados) =>
  api.post('/billing/solicitar-modulo', dados).then(r => r.data);

// ── Admin — gestão por instituição ───────────────────────────────────────────

export const obterDetalheInstituicaoAdmin = (instituicaoId) =>
  api.get(`/billing/admin/instituicao/${instituicaoId}`).then(r => r.data);

export const ajustarModuloInstituicao = (instituicaoId, moduloCodigo, dados) =>
  api.patch(`/billing/admin/instituicao/${instituicaoId}/modulo/${moduloCodigo}`, dados).then(r => r.data);
